import { Component, Input } from '@angular/core';
import { BarcodeFormatEnum, BarcodeScannerEnum } from './enum/barcode-scanner.enum';

@Component({
  selector: 'app-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styles: ['']
})
export class BarcodeScannerComponent {
  @Input() barcodeFormat: BarcodeFormatEnum = BarcodeFormatEnum.Pdf417;

  showTab: number = BarcodeScannerEnum.HiddenComponents;

  showScanner(): void {
    this.showTab = BarcodeScannerEnum.ShowBarcodeScannerComponent;
  }

  showUploadFile(): void {
    this.showTab = BarcodeScannerEnum.ShowUploadFileComponent;
  }

  get showScannerView() {
    return this.showTab === BarcodeScannerEnum.ShowBarcodeScannerComponent;
  }

  get showUploadFileView() {
    return this.showTab === BarcodeScannerEnum.ShowUploadFileComponent;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/barcode-scanner/barcode-scanner.component.ts